import React from 'react';

/** Shared ambient accent glow layer to keep pages consistent with the players. */
const AmbientGlow = () => (
  <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
    <div className="absolute -top-24 -left-24 w-80 h-80 rounded-full opacity-[0.18] blur-3xl" style={{ background: '#FF007F' }} />
    <div className="absolute top-1/3 -right-24 w-80 h-80 rounded-full opacity-[0.10] blur-3xl" style={{ background: '#00F0FF' }} />
    <div className="absolute bottom-0 left-1/3 w-72 h-72 rounded-full opacity-[0.08] blur-3xl" style={{ background: '#B14BFF' }} />
  </div>
);

export default AmbientGlow;
